import { errWithCause } from "pino-std-serializers";

// Customer PII keys, matched case-insensitively at any depth. The server-side relay only redacts
// two levels deep, and these turn up nested in whole Task / callback / notification payloads.
const REDACTED_KEYS = new Set([
    "customername",
    "customeremailid",
    "customermdn",
    "customerchatid",
    "email",
    "mdn",
    "callbackmdn",
    "callerid",
    "phonenumber",
]);

export const REDACTED = "[Redacted]";

export function jsonReplacer(key: string, value: unknown) {
    // Twilio data has a LOT of private members that may hold sensitive information like our auth token
    // These are all prefixed with an underscore, so we can filter them out here
    if (key.startsWith("_")) return undefined;

    if (REDACTED_KEYS.has(key.toLowerCase()) && value !== undefined && value !== null) return REDACTED;

    // https://github.com/pinojs/pino/issues/2132
    if (value instanceof Error) return errWithCause(value);

    return value;
}
